import { TimecardStatusEnum } from '../../timecards/enums';
import { timecardsOnListen } from '../../timecards/timecardsAPI';
import { TimecardsReducerState } from '../../timecards/types';

const ORGANIZATION_TIMECARDS_FETCHED = 'ORGANIZATION_TIMECARDS_FETCHED';

type TimecardsFetchedActionType = {
  type: string;
  timecards: TimecardsReducerState;
};

export const timecardsFetchedAction = (timecards: TimecardsReducerState) => ({
  type: ORGANIZATION_TIMECARDS_FETCHED,
  timecards,
});

export const startOrganizationClockedInListener =
  (organizationId: string) => (dispatch: (event: TimecardsFetchedActionType) => void) => {
    const conditions = [{ field: 'status', operation: '==', value: TimecardStatusEnum.CLOCKED_IN } as const];

    return timecardsOnListen(
      { organizationId, conditions },
      (timecards: TimecardsReducerState) => {
        if (timecards) dispatch(timecardsFetchedAction(timecards));
      },
      (error) => console.log(error.message),
      () => null
    );
  };
const initialState = {
  count: 0,
  list: [],
} as TimecardsReducerState;

export const timecardsReducer = (state = initialState, action: TimecardsFetchedActionType) => {
  switch (action.type) {
    case ORGANIZATION_TIMECARDS_FETCHED:
      return {
        count: action.timecards.count,
        list: action.timecards.list,
      };
    default:
      return state;
  }
};
